// @ts-nocheck
import styled from 'styled-components';

export const MainSettingsPanelStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  .mainSettingsPanel__section {
    display: flex;
    flex-direction: column;
    gap: 16px;

    &__box {
      box-shadow: 0 -1.3px 13px 0 rgba(18, 22, 30, 0.05);
    }

    &__title {
      font-family: ${props => props.theme.fontSemiBold};
      font-size: ${props => props.theme.fontSizeS};
      height: 16px;
      color: ${props => props.theme.uiColors.textBodyDefault};
    }

    &__content {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }
  }
`;
